














































































import Vue from "vue";
import { axios } from "@/plugins";
import { Form } from "element-ui";
import { Itolerations } from "./transform";

const operator = [
  { label: "存在", value: "Exists" },
  { label: "等于", value: "Equal" }
];
const effect = {
  NoSchedule: "不允许调度",
  PreferNoSchedule: "尽量不调度",
  NoExecute: "驱逐已有容器组"
};
export default Vue.extend({
  name: "StaintEdit",
  data() {
    return {
      dialog: false,
      operator,
      effect,
      ruleForm: {
        form: [] as Itolerations[]
      },
      taints: [] as { effect: string; key: string; value: string }[]
    };
  },
  computed: {
    filterTanits(): { effect: string; key: string; value: string }[] {
      if (this.ruleForm.form.length === 0) return this.taints;
      return this.taints.filter(({ key }) => {
        return !this.ruleForm.form.some(item => item.key === key);
      });
    }
  },
  methods: {
    show(data?: Itolerations[]) {
      if (data) {
        // todo 回填参数
        data.forEach(item => {
          this.ruleForm.form.push({
            key: item.key,
            value: item.value,
            operator: item.operator,
            effect: item.effect
          });
        });
      }

      if (this.ruleForm.form.length === 0) {
        this.addTaint();
      }
      this.dialog = true;
      this.getLabels();
    },
    getLabels() {
      axios.get("/hosts/all/taints").then(res => {
        this.taints = res.data.data;
      });
    },
    keyChange(val: string, index: number) {
      const data = this.taints.find(item => item.key === val);
      if (data) {
        this.ruleForm.form[index].effect = data.effect as any;
        this.ruleForm.form[index].value = data.value;
        this.ruleForm.form[index].operator = "Equal";
      }
    },
    // 操作变更
    opChange(val: string, index: number) {
      const key = this.ruleForm.form[index].key;
      if (val === "Equal") {
        const data = this.taints.find(item => item.key === key);
        if (data) {
          this.ruleForm.form[index].value = data.value;
        }
      } else {
        this.ruleForm.form[index].value = "";
      }
    },
    quit() {
      this.ruleForm = {
        form: []
      };
      (this.$refs.ruleForm as Form).clearValidate();

      this.dialog = false;
    },
    submit() {
      (this.$refs.ruleForm as any).validate((valid: any) => {
        if (valid) {
          this.create();
        }
      });
    },
    create() {
      if (!this.ruleForm.form.length) {
        this.quit();
      }
      const data: Itolerations[] = JSON.parse(
        JSON.stringify(this.ruleForm.form)
      );
      this.$emit("afterEdit", data);
      this.quit();
    },
    edlTaint(index: number) {
      this.ruleForm.form.splice(index, 1);
    },
    addTaint() {
      this.ruleForm.form.push({
        key: "",
        value: "",
        operator: undefined,
        effect: undefined
      });
    }
  }
});
